import fileMediaImagePlayer from './file-media-image-player'
export default fileMediaImagePlayer
